import { createApp } from 'vue'
import {createMemoryHistory, createRouter, createWebHistory} from 'vue-router'
import App from './App.vue'
import rutas from './rutas'
import store from './vuex'
import {validaToken} from "@/api/api";
import { emitter } from '@/eventBus';




const router = createRouter({
  routes: rutas,
  history: createWebHistory(),
})




router.beforeEach((to, from, next) => {
  console.log(to, from)
  if(to.fullPath.includes('/in/')){
    emitter.off('enviarCodigo')

    next()
  }
  else {

    emitter.off('showModal')
    next()
  }



})

router.beforeResolve((to,from,next)=>{

  const empresa = window.localStorage.empresa ? window.localStorage.empresa : ''

  if(to.path.includes('/in')){
    if(!window.localStorage.token) return next(`/${empresa}`)
    else {
      validaToken().then(()=>{

        next()
      }).catch(error=>{
        console.log(error)
        next(`/${empresa}/sesionInvalida`, )
      })
    }

  }
  else return next()
})



const app = createApp(App)
app.use(store)
app.use(router)
app.mount('#app')

// new Vue({
//   el: '#app',
//   render: h => h(App),
//   router,
//   store
// })
